module.exports = __webpack_public_path__ + "img/vertical_4_1_7016.69b1a607.png";